<template>
    <section id="Sponsors" class="sponsors-section">
        <div class="sponsors-heading">
            <div>
                <span class="section-kicker">Powered by partnership</span>
                <h2>Our sponsors</h2>
                <p>We are grateful to the organizations investing in the next generation of builders, creators, and leaders.</p>
            </div>
            <a class="sponsor-cta" href="mailto:info@codettes.org">
                Become a sponsor
                <v-icon small>fas fa-arrow-right</v-icon>
            </a>
        </div>

        <div class="sponsor-grid">
            <a
                v-for="sponsor in sponsors"
                :key="sponsor.title"
                :href="sponsor.website"
                target="_blank"
                rel="noopener noreferrer"
                class="sponsor-card"
                :aria-label="`Visit ${sponsor.title} website`"
            >
                <div class="logo-frame">
                    <img :src="sponsor.image" :alt="`${sponsor.title} logo`" />
                </div>
                <span class="sponsor-name">{{ sponsor.title }}</span>
                <v-icon class="sponsor-arrow" small>fas fa-arrow-up-right-from-square</v-icon>
            </a>
        </div>
    </section>
</template>

<script>
    export default {
        name: "CSponsors",
        data: () => ({
            sponsors: [
                { image: '/usembassy.svg', title: 'U.S. Embassy', website: 'https://www.usembassy.gov/' },
                { image: '/kosmosenergy.svg', title: 'Kosmos Energy', website: 'https://www.kosmosenergy.com/' },
                { image: '/TullowOil2.svg', title: 'Tullow Oil', website: 'https://www.tullowoil.com/' },
                { image: '/chevron.svg', title: 'Chevron', website: 'https://www.chevron.com/' },
                { image: '/IOTLab.jpeg', title: 'IoT Lab SU', website: 'https://www.facebook.com/iotlabsu' },
                { image: '/lybra.png', title: 'Lybra Group', website: 'https://www.lybragroup.com/' },
                { image: '/qualogy.png', title: 'Qualogy', website: 'https://www.qualogy.com/' }
            ]
        })
    }
</script>

<style scoped>
    .sponsors-section {
        background: #fff;
        border-top: 1px solid #ece7f5;
        padding: 88px 8% 96px;
    }

    .sponsors-heading {
        align-items: flex-end;
        display: flex;
        gap: 32px;
        justify-content: space-between;
        margin: 0 auto 34px;
        max-width: 1180px;
    }

    .section-kicker {
        color: #a8007c;
        display: block;
        font-size: .72rem;
        font-weight: 800;
        letter-spacing: .18em;
        margin-bottom: 10px;
        text-transform: uppercase;
    }

    h2 { color: #24123f; font-size: clamp(2rem, 4vw, 3.25rem); letter-spacing: -.04em; margin: 0 0 12px; }
    .sponsors-heading p { color: #696276; font-size: 1rem; line-height: 1.7; margin: 0; max-width: 590px; }
    .sponsor-cta { color: #a8007c; font-size: .9rem; font-weight: 800; white-space: nowrap; }
    .sponsor-cta .v-icon { color: inherit; margin-left: 7px; transition: transform .2s ease; }
    .sponsor-cta:hover .v-icon { transform: translateX(4px); }

    .sponsor-grid { display: grid; gap: 16px; grid-template-columns: repeat(4, minmax(0, 1fr)); margin: 0 auto; max-width: 1180px; }
    .sponsor-card { align-items: center; background: #fbfaff; border: 1px solid #eeeaf6; border-radius: 16px; color: #24123f; display: flex; flex-direction: column; min-height: 184px; padding: 22px 18px 18px; position: relative; text-align: center; transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease; }
    .sponsor-card:hover, .sponsor-card:focus-visible { border-color: #d9b2d0; box-shadow: 0 14px 30px rgba(50, 20, 77, .1); outline: none; transform: translateY(-4px); }
    .logo-frame { align-items: center; background: #fff; border-radius: 12px; display: flex; height: 94px; justify-content: center; margin-bottom: 17px; padding: 13px 22px; width: 100%; }
    .logo-frame img { display: block; height: 64px; max-height: 100%; max-width: 170px; object-fit: contain; width: auto; }
    .sponsor-name { font-size: .86rem; font-weight: 800; }
    .sponsor-arrow { color: #a8007c !important; opacity: 0; position: absolute; right: 14px; top: 14px; transition: opacity .2s ease; }
    .sponsor-card:hover .sponsor-arrow, .sponsor-card:focus-visible .sponsor-arrow { opacity: 1; }

    @media (max-width: 900px) { .sponsor-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
    @media (max-width: 600px) {
        .sponsors-section { padding: 64px 20px 72px; }
        .sponsors-heading { align-items: flex-start; flex-direction: column; gap: 20px; }
        .sponsor-grid { gap: 12px; grid-template-columns: repeat(2, minmax(0, 1fr)); }
        .sponsor-card { min-height: 160px; padding: 15px 10px; }
        .logo-frame { height: 78px; padding: 10px; }
        .logo-frame img { height: 52px; max-width: 130px; }
    }
</style>
